import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-60e302c2")
const _hoisted_1 = { class: "justify-center d-flex" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "ml-2 text-h5"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("mdi-lock-open")
_popScopeId()

import { getInstance } from '@/auth'
import { computed, ref, withDefaults } from 'vue'
import { useRouter } from 'vue-router'

interface IProps {
  showCollapsed: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
    showCollapsed: { type: Boolean, required: true, default: true }
  },
  setup(__props: any) {

const props = __props as { showCollapsed: boolean }


const auth = getInstance()
const router = useRouter()

const hoverOverNavDrawer = ref(false)
const navItems = [
  {
    label: 'navigation.automations',
    to: '/automations',
    icon: 'mdi-clipboard-flow-outline'
  }
]

// TODO vuetify 3 navbar, remove as soon as collapse is available
const showCollapsed = computed((): boolean => {
  // collapse navbar if editor is active and not hovered
  return props.showCollapsed && !hoverOverNavDrawer.value
})

const logout = (): void => {
  auth.logout()
  router.push({ path: '/' })
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_icon = _resolveComponent("v-list-item-icon")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "navbar" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_navigation_drawer, {
        permanent: "",
        "expand-on-hover": _unref(showCollapsed),
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (hoverOverNavDrawer.value = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hoverOverNavDrawer.value = false)),
        width: _unref(showCollapsed) ? 60 : 300,
        class: "pt-5"
      }, {
        append: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, { onClick: logout }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_icon, { class: "mr-3" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item_title, { class: "text-body-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('navigation.logout')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, { class: "pt-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, { class: "justify-center px-2 mb-5 d-flex" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("img", {
                          src: require('@/assets/images/logo.png').default,
                          width: "30"
                        }, null, 8, _hoisted_2),
                        (!_unref(showCollapsed))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Hoppermation"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_list, {
            nav: "",
            dense: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
                return _createVNode(_component_v_list_item, {
                  link: "",
                  key: item.to,
                  to: item.to,
                  href: item.href,
                  target: item.target,
                  rel: item.rel
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_icon, { class: "mr-3" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.icon), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_list_item_title, { class: "text-body-1" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["to", "href", "target", "rel"])
              }), 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["expand-on-hover", "width"])
    ]),
    _: 1
  }))
}
}

})